import React from 'react'
import { useState, useEffect, useRef } from 'react'
import GreenButton from '../../../components/forms/greenButton'
import BlueButton from '../../../components/forms/blueButton'
import FormInput from '../../../components/forms/formInput'
import FormSelect from '../../../components/forms/formSelect'
import FormTextarea from '../../../components/forms/formTextarea'
import PimaryInputSelect from '../../../components/forms/pimaryInputSelect'
import IntrustInputSelect from '../../../components/forms/intrustInputSelect'
import '../../../css/components/public/listings.css'
import { useNavigate } from 'react-router-dom'
import ListingIntust from '../../../components/public/others/listingIntust'
import { useParams } from 'react-router-dom'
import ApiUrl from '../../../configTools/apiUrl'
import ScreenSizes from '../../../configTools/screenSizes'
import RedButton from '../../../components/forms/redButton'

const Listingedit = () => {
  const {value} = useParams();
  const IntrustAddBox = useRef(null)
  const recommendationsPop = useRef(null);
  const Admin = JSON.parse(localStorage.getItem("user-info"));
  const [User,setUser] = useState({});
  const navigate = useNavigate();
  const [id,setID] = useState(0);
  const [title,setTitle] = useState('');
  const [discription,setDiscription] = useState('');
  const [sku,setSku] = useState('');
  const [price,setPrice] = useState(0);
  const [compareatprice,setCompareatprice] = useState(0);
  const [brand,setBrand] = useState({name:'Select', value:'0'});
  const [brandList,setBrandList] = useState([]);
  const [condition,setCondition] = useState({name:'Select', value:'0'});
  const [conditionList,setConditionList] = useState([]);
  const [category,setCategory] = useState({name:'Select', value:'0'});
  const [categoryList,setCategoryList] = useState([]);
  const [subcategory,setSubcategory] = useState({name:'Select', value:'0'});
  const [subcategoryList,setSubcategoryList] = useState([]);
  const [allcategoryList,setAllCategoryList] = useState([]);
  const [state,setState] = useState({name:'Fashion', value:'1'});
  const [stateList,setStateList] = useState([]);
  const [images,setImages] = useState([]);
  const [colors,setColors] = useState([]);
  const [colorsList,setColorsList] = useState([]);
  const [colorsFilter,setColorsFilter] = useState([]);
  const [type,setType] = useState({name:'Select', value:'0'});
  const [typeList,setTypeList] = useState([]);
  const [sizes,setSizes] = useState([]);
  const [sizesList,setSizesList] = useState([]);
  const [sizesFilter,setSizesFilter] = useState([]);
  const [intrusts,setIntrusts] = useState([]);
  const [intrustsList,setIntrustsList] = useState([]);
  const [intrustsFilter,setIntrustsFilter] = useState([]);
  const [recommendations,setRecommendations] = useState([]);
  const [recommendationsList,setRecommendationsList] = useState([]);
  const [recommendationsFilter,setRecommendationsFilter] = useState([]);
  const [listCollection,setListCollection] = useState([]);
  const [listCollectionList,setListCollectionList] = useState([]);
  const [listCollectionFilter,setListCollectionFilter] = useState([]);

  const [hasVarients,setHasvarients] = useState(false);
  const [deliveryType,setDeliveryType] = useState({name:'Select', value:'0'});
  const [deliveryTypeList,setdeliveryTypeList] = useState([{name:'Inventory', value:'1'},{name:'Days', value:'2'},{name:'Months', value:'3'}]);
  const [counter,setCounter] = useState(0);
  const [varients,setVarients] = useState([]);

  const [packaging,setPackaging] = useState({name:'Flyer', value:'1'});
  const [packagingList,setpackagingList] = useState([{name:'Flyer', value:'1'},{name:'Box', value:'2'}]);


  const [hscode,setHscode] = useState('');
  const [weight,setWeight] = useState(0);
  const [pwidth,setWidth] = useState(0);
  const [pheight,setHeight] = useState(0);
  const [plength,setLength] = useState(0);

  var isUpdating = false;

  const [item,setItem] = useState(null);

  const addRecommendation = (e)=>{
    if(recommendations.length > 8){
      return;
    }
    if(recommendations.find(x=>x.id === e.id)){
      return;
    }
    let recommendationsArray = recommendations;
    recommendationsArray.push(e);
    setRecommendations(recommendationsArray);
    let filteredrecommendations = recommendationsList.filter((item)=> {
      return !recommendationsArray.find((itemB)=> {
        return item.id === itemB.id;
      })
    })
    setRecommendationsFilter(filteredrecommendations);
  }
  const removeRecommendation = (e) =>{
    let recommendationsArray = recommendations.filter((item)=> {
      return item.id !== e.id
    })
    setRecommendations(recommendationsArray);
    let filteredrecommendations = recommendationsList.filter((item)=> {
      return !recommendationsArray.find((itemB)=> {
        return item.id === itemB.id;
      })
    })
    setRecommendationsFilter(filteredrecommendations);
  }

  const recommendationsPopUp = ()=>{
    recommendationsPop.current.className = "listing_recommendations_popup_wrapper active";
  }
  const recommendationsPopDown = ()=>{
    recommendationsPop.current.className = "listing_recommendations_popup_wrapper";
  }

  const addIntrust = (e)=>{
    if(intrusts.length > 4){
      return;
    }
    if(intrusts.find(x=>x.value === e.value)){
      return;
    }
    let intrustsArray = intrusts;
    intrustsArray.push(e);
    setIntrusts(intrustsArray);
    let filteredIntrusts = intrustsList.filter((item)=> {
      return !intrustsArray.find((itemB)=> {
        return item.value === itemB.value;
      })
    })
    setIntrustsFilter(filteredIntrusts);
  }
  const removeIntrust = (e) =>{
    let intrustsArray = intrusts.filter((item)=> {
      return item.value !== e.value
    })
    setIntrusts(intrustsArray);
    let filteredIntrusts = intrustsList.filter((item)=> {
      return !intrustsArray.find((itemB)=> {
        return item.value === itemB.value;
      })
    })
    setIntrustsFilter(filteredIntrusts);
  }
  const addColor = (e)=>{
    if(colors.find(x=>x.value === e.value)){
      return;
    }
    let intrustsArray = colors;
    intrustsArray.push(e);
    setColors(intrustsArray);
    let filteredIntrusts = colorsFilter.filter((item)=> {
      return !intrustsArray.find((itemB)=> {
        return item.value === itemB.value;
      })
    })
    setColorsFilter(filteredIntrusts);
  }
  const removeColor = (e) =>{
    let intrustsArray = colors.filter((item)=> {
      return item.value !== e.value
    })
    setColors(intrustsArray);
    let filteredIntrusts = colorsList.filter((item)=> {
      return !intrustsArray.find((itemB)=> {
        return item.value === itemB.value;
      })
    })
    setColorsFilter(filteredIntrusts);
  }
  const addSize = (e)=>{
    if(sizes.find(x=>x.value === e.value)){
      return;
    }
    let intrustsArray = sizes;
    intrustsArray.push(e);
    setSizes(intrustsArray);
    let filteredIntrusts = sizesFilter.filter((item)=> {
      return !intrustsArray.find((itemB)=> {
        return item.value === itemB.value;
      })
    })
    setSizesFilter(filteredIntrusts);
  }
  const removeSize = (e) =>{
    let intrustsArray = sizes.filter((item)=> {
      return item.value !== e.value
    })
    setSizes(intrustsArray);
    let filteredIntrusts = sizesList.filter((item)=> {
      return !intrustsArray.find((itemB)=> {
        return item.value === itemB.value;
      })
    })
    setSizesFilter(filteredIntrusts);
  }

  const addCollection = (e)=>{
    if(listCollection.find(x=>x.value === e.value)){
      return;
    }
    let intrustsArray = listCollection;
    intrustsArray.push(e);
    setListCollection(intrustsArray);
    let filteredIntrusts = listCollectionFilter.filter((item)=> {
      return !intrustsArray.find((itemB)=> {
        return item.value === itemB.value;
      })
    })
    setListCollectionFilter(filteredIntrusts);
  }
  const removeCollection = (e) =>{
    let intrustsArray = listCollection.filter((item)=> {
      return item.value !== e.value
    })
    setListCollection(intrustsArray);
    let filteredIntrusts = listCollectionList.filter((item)=> {
      return !intrustsArray.find((itemB)=> {
        return item.value === itemB.value;
      })
    })
    setListCollectionFilter(filteredIntrusts);
  }

  const get_admin_select = () =>{
  }
  const change_state = (v) =>{
    let collectionListSend = [];
    setCategory({name:'Select', value:'0'});
    setSubcategory({name:'Select', value:'0'});
    if(parseInt(v.value) === 1){
      for (let index = 0; index < allcategoryList.length; index++) {
        const element = allcategoryList[index];
        if(element.parentid === 0){
          if(element.type === 1){
            collectionListSend.push({
              name: element.title,
              value: String(element.id)
            })
          }
        }
      }
    }
    else{
      for (let index = 0; index < allcategoryList.length; index++) {
        const element = allcategoryList[index];
        if(element.parentid === 0){
          if(element.type === 2){
            collectionListSend.push({
              name: element.title,
              value: String(element.id)
            })
          }
        }
      }
    }
    setCategoryList(collectionListSend);
    setState(v);
  }
  const change_category = (v) =>{
    let collectionListSend = [];
    for (let index = 0; index < allcategoryList.length; index++) {
      const element = allcategoryList[index];
      if(String(element.parentid) === v.value){
        collectionListSend.push({
          name: element.title,
          value: String(element.id)
        })
      }
    }
    setSubcategoryList(collectionListSend);
    setCategory(v);
  }
  const change_type = (v) =>{
    fetch(ApiUrl.API_URL_ListingType+"/"+v.value)
    .then(res=>res.json())
    .then(data =>{
        let sizeListSend = [];
        for (let index = 0; index < data.sizeList.length; index++) {
          const element = data.sizeList[index];
          sizeListSend.push({
            name: element.name,
            value: String(element.id)
          })
        }
        setSizesList(sizeListSend);
        setSizesFilter(sizeListSend);
    });
    setSizes([]);
    setType(v);
  }
  useEffect(() => {
    fetch(ApiUrl.API_URL_ListingEditUserInfo+"/"+value, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+Admin.token
        }
    })
    .then(res=>res.json())
    .then(data =>{
        if(data.success){
          setUser(data.responce);
        }
    });
    setStateList([{name:'Fashion', value:'1'},{name:'Art & Lifestyle', value:'2'}])
  },[])
  useEffect(() => {
    fetch(ApiUrl.API_URL_Listing+"/"+value)
    .then(res=>res.json())
    .then(data =>{
        if(data.success){
          setItem(data.responce);
        }
    });
  },[User])
  useEffect(()=>{
    if(item === null){
      return;
    }
    isUpdating = true;
    setID(item.id)
    setDiscription(item.discription)
    setCompareatprice(item.compareatprice)
    setPrice(item.price)
    setSku(item.sku)
    setTitle(item.title)
    setWeight(item.weight)
    setLength(item.length)
    setWidth(item.width)
    setHeight(item.height)
    setHscode(item.hscode)
    fetch(ApiUrl.API_URL_Intrust)
    .then(res=>res.json())
    .then(data =>{
        let intrustListSend = [];
        for (let index = 0; index < data.length; index++) {
          const element = data[index];
          intrustListSend.push({
            name: element.name,
            value: String(element.id)
          })
        }
        setIntrustsList(intrustListSend);
        setIntrustsFilter(intrustListSend);
    });
    fetch(ApiUrl.API_URL_Color)
    .then(res=>res.json())
    .then(data =>{
        let colorListSend = [];
        for (let index = 0; index < data.length; index++) {
          const element = data[index];
          colorListSend.push({
            name: element.name,
            value: String(element.id),
            code: element.code
          })
        }
        setColorsList(colorListSend);
        setColorsFilter(colorListSend);
    });
    fetch(ApiUrl.API_URL_ListCollection)
    .then(res=>res.json())
    .then(data =>{
        let colorListSend = [];
        for (let index = 0; index < data.length; index++) {
          const element = data[index];
          colorListSend.push({
            name: element.name,
            value: String(element.id)
          })
        }
        setListCollectionList(colorListSend);
        setListCollectionFilter(colorListSend);
    });
    fetch(ApiUrl.API_URL_Brand)
    .then(res=>res.json())
    .then(data =>{
        let brandListSend = [];
        for (let index = 0; index < data.length; index++) {
          const element = data[index];
          brandListSend.push({
            name: element.name,
            value: String(element.id)
          })
          if(element.id === item.brand){
            setBrand({
              name: element.name,
              value: String(element.id)
            });
          }
        }
        setBrandList(brandListSend);
    });
    fetch(ApiUrl.API_URL_Condition)
    .then(res=>res.json())
    .then(data =>{
        let conditionListSend = [];
        for (let index = 0; index < data.length; index++) {
          const element = data[index];
          conditionListSend.push({
            name: element.name,
            value: String(element.id)
          })
          if(element.id === item.condition){
            setCondition({
              name: element.name,
              value: String(element.id)
            });
          }
        }
        setConditionList(conditionListSend);
    });
    fetch(ApiUrl.API_URL_Collection)
    .then(res=>res.json())
    .then(data =>{
        setAllCategoryList(data);
        let collectionListSend = [];
        for (let index = 0; index < data.length; index++) {
          const element = data[index];
          if(element.parentid === 0){
            if(User.role === 'individual' || User.role === 'business'){
              if(element.type === 1){
                collectionListSend.push({
                  name: element.title,
                  value: String(element.id)
                })
              }
            }
            else{
              if(element.type === 3){
                collectionListSend.push({
                  name: element.title,
                  value: String(element.id)
                })
              }
            }
          }
        }
        setCategoryList(collectionListSend);
        for (let index = 0; index < collectionListSend.length; index++) {
          const currentCollection = collectionListSend[index];
          if(currentCollection.value === String(item.category)){
            let collectionListSend2 = []
            for (let index = 0; index < data.length; index++) {
              const element = data[index];
              if(String(element.parentid) === currentCollection.value){
                collectionListSend2.push({
                  name: element.title,
                  value: String(element.id)
                })
                if(element.id === item.subcategory){
                  setSubcategory({
                    name: element.title,
                    value: String(element.id)
                  });
                }
              }
            }
            setSubcategoryList(collectionListSend2);
            setCategory(currentCollection);
          }
        }
        
    });
    fetch(ApiUrl.API_URL_ListingType)
    .then(res=>res.json())
    .then(data =>{
        let listingTypeListSend = [];
        for (let index = 0; index < data.length; index++) {
          const element = data[index];
          listingTypeListSend.push({
            name: element.name,
            value: String(element.id)
          })
          if(element.id === item.type){
            setSizes([]);
            fetch(ApiUrl.API_URL_ListingType+"/"+element.id)
            .then(res=>res.json())
            .then(data2 =>{
                let sizeListSend = [];
                for (let index = 0; index < data2.sizeList.length; index++) {
                  const element2 = data2.sizeList[index];
                  sizeListSend.push({
                    name: element2.name,
                    value: String(element2.id)
                  })
                }
                setSizesList(sizeListSend);
                setSizesFilter(sizeListSend);
                setTimeout(() => {
                  for (let index = 0; index < item.sizes.length; index++) {
                    const element3 = item.sizes[index];
                    if(sizeListSend.find(x=>x.value === String(element3.size))){
                      addSize(sizeListSend.find(x=>x.value === String(element3.size)));
                    }
                  }
                }, 1000);
            });
            setType({
              name: element.name,
              value: String(element.id)
            });
          }
        }
        setTypeList(listingTypeListSend);
    });
    var dbimages = [];
    for (let index = 0; index < item.images.length; index++) {
        const element = item.images[index];
        dbimages.push(element.url);
    }
    setImages(dbimages);

    fetch(ApiUrl.API_URL_ListingUser+"/"+User.username)
    .then(res=>res.json())
    .then(data =>{
        if(data.success)
        setRecommendationsList(data.responce);
        setRecommendationsFilter(data.responce);
        setTimeout(() => {
          for (let index = 0; index < item.listingRecommends.length; index++) {
            const element = item.listingRecommends[index];
            if(data.responce.find(x=>x.id === element.childid)){
              addRecommendation(data.responce.find(x=>x.id === element.childid));
            }
          }
        }, 2000);
    });
    for (let index = 0; index < deliveryTypeList.length; index++) {
      const element = deliveryTypeList[index];
      if(element.value === String(item.deliverytype)){
        setDeliveryType({
          name: element.name,
          value: String(element.value)
        });
      }
    }
    for (let index = 0; index < packagingList.length; index++) {
      const element = packagingList[index];
      if(element.value === String(item.packing)){
        setPackaging({
          name: element.name,
          value: String(element.value)
        });
      }
    }
    setCounter(item.counter);
    setHasvarients(item.hasVarients);
    if(item.hasVarients){
      var varientSendList = [];
      for (let index = 0; index < item.listingVarients.length; index++) {
        const varient = item.listingVarients[index];
        var deliveryTypeSend = {name:'Select', value:'0'}
        for (let index = 0; index < deliveryTypeList.length; index++) {
          const element = deliveryTypeList[index];
          if(element.id === varient.deliverytype){
            deliveryTypeSend = {
              name: element.name,
              value: String(element.id)
            }
          }
        }
        varientSendList.push({
          title: varient.title,
          sku: varient.sku,
          price: varient.price,
          compareatprice:varient.compareatprice,
          deliverytype:deliveryTypeSend,
          count: varient.count,
          size: varient.size,
          color: varient.color
        })
      }
      setVarients(varientSendList);
    }
    isUpdating = false;
  },[item])
  useEffect(()=>{
    if(intrustsList.length === 0){
      return;
    }
    for (let index = 0; index < item.intrusts.length; index++) {
      const element = item.intrusts[index];
      let sendIntrust = intrustsList.find(x => x.value === String(element.id));
      addIntrust(sendIntrust);
    }
  },[intrustsList])
  useEffect(()=>{
    isUpdating = true;
    if(colorsList.length === 0){
      return;
    }
    for (let index = 0; index < item.colors.length; index++) {
      const element = item.colors[index];
      let colorSend = colorsList.find(x => x.value === String(element.id));
      addColor(colorSend);
    }
    isUpdating = false;
  },[colorsList])
  useEffect(()=>{
    if(listCollectionList.length === 0){
      return;
    }
    for (let index = 0; index < item.listCollectionItems.length; index++) {
      const element = item.listCollectionItems[index];
      let colorSend = listCollectionList.find(x => x.value === String(element.listcollectionid));
      addCollection(colorSend);
    }
  },[listCollectionList])

  const showPreview = (e) =>{
    if(images.length > 4){
      return;
    }
    if(e.target.files && e.target.files[0]){
        let imageFile = e.target.files[0];
        const formData = new FormData();
        formData.append("file",imageFile);
        fetch(ApiUrl.API_URL_File, {
          method: 'POST',
          body: formData
        })
        .then(res=>res.json())
        .then(data =>{
            if(data.success){
              let imageList = images;
              imageList.push(data.url);
              setImages(imageList);
              setPrice(price);
            }
            else{
                console.log(data.responce);
            }
        });
    }
  }
  const remove_image = (e)=>{
    let imageList = [];
    for (let index = 0; index < images.length; index++) {
        if(index !== e){
            const element = images[index];
            imageList.push(element);
        }
    }
    setImages(imageList);
  }

  function add_admin(activate){
    let stateSend = 0;
    if(User.role === 'individual'){
      stateSend = 1;
    }
    else if(User.role === 'business'){
      if(state.value === '1'){
        stateSend = 2;
      }
      else{
        stateSend = 3;
      }
    }
    else{
      stateSend = 4;
    }
    if(sizes.length < 1){
        alert("Size is missing");
        return;
    }
    if(images.length < 1){
        alert("Image is missing");
        return;
    }
    if(colors.length < 1){
        alert("Color is missing");
        return;
    }
    if(brand.value === "0"){
      alert("Brand not selected");
      return;
    }
    if(condition.value === "0"){
      alert("Condition not selected");
      return;
    }
    if(category.value === "0"){
      alert("Category not selected");
      return;
    }
    if(deliveryType.value === "0"){
      alert("Delivery not selected");
      return;
    }
    if(intrusts.length < 1){
        alert("Intrust is missing");
        return;
    }
    if(hasVarients){
      var errorVarients = false;
      for (let index = 0; index < varients.length; index++) {
        const element = varients[index];
        if(element.price === "" || element.price === 0 || element.price === undefined ){
          errorVarients = true;
        }
        if(element.deliverytype.value === "0" ){
          errorVarients = true;
        }
      }
      if(errorVarients){
        alert("Varient fields are empty");
        return;
      }
      if(varients.length < 1){
        alert("Varient are empty");
        return;
      }
    }
    let sizeList = [];
    for (let index = 0; index < sizes.length; index++) {
        const element = sizes[index];
        sizeList.push({
          size: parseInt(element.value)
        })
    }
    let imagesList = [];
    for (let index = 0; index < images.length; index++) {
        const element = images[index];
        imagesList.push({
          url: element
        })
    }
    let colorList = [];
    for (let index = 0; index < colors.length; index++) {
        const element = colors[index];
        colorList.push({
          id: parseInt(element.value)
        })
    }
    let intrustList = [];
    for (let index = 0; index < intrusts.length; index++) {
        const element = intrusts[index];
        intrustList.push({
          id: parseInt(element.value)
        })
    }
    let RList = [];
    for (let index = 0; index < recommendations.length; index++) {
      const element = recommendations[index];
      RList.push({
        id:0,
        listingid:0,
        childid:element.id
      });
    }
    var sendVarientList = [];
    for (let index = 0; index < varients.length; index++) {
      const element = varients[index];
      sendVarientList.push({
        title: element.title,
        sku: element.sku,
        price: element.price,
        compareatprice:element.compareatprice,
        deliverytype:parseInt(element.deliverytype.value),
        count: element.count,
        size: element.size,
        color: element.color
      })
    }
    var sendListCollection = [];
    for (let index = 0; index < listCollection.length; index++) {
      const element = listCollection[index];
      sendListCollection.push({
        id: 0,
        listcollectionid: parseInt(element.value),
        productid: 0,
      })
    }
    fetch(ApiUrl.API_URL_ListingUpdate, {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer '+Admin.token
      },
      body: JSON.stringify({
        id:id,
        title: title,
        discription: discription,
        userid : User.id,
        sku: sku,
        price: parseInt(price),
        compareatprice: compareatprice == ''? 0 : parseInt(compareatprice),
        brand: parseInt(brand.value),
        condition: parseInt(condition.value),
        type: parseInt(type.value),
        category: parseInt(category.value),
        subcategory: parseInt(subcategory.value),
        state: stateSend,
        colors: colorList,
        sizes: sizeList,
        images: imagesList,
        intrusts: intrustList,
        ListingRecommends: RList,
        counter : counter,
        deliverytype : parseInt(deliveryType.value),
        hasVarients : hasVarients,
        ListingVarients: sendVarientList,
        ListCollectionItems : sendListCollection,
        length : plength,
        height : pheight,
        width : pwidth,
        hscode : hscode,
        weight : weight,
        packing : parseInt(packaging.value)
      })
    })
    .then(res=>res.json())
    .then(data =>{
      if(data.success){
        if(activate === 1){
          fetch(ApiUrl.API_URL_ListingActive, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+Admin.token
            },
            body: JSON.stringify({
              id:item.id,
              active: true
            })
          })
          .then(res2=>res2.json())
          .then(data2 =>{
            if(data2.success){
              navigate('/admin/products/listing/2');
            }
            else{
              alert('Saved but activation failed');
            }
          });
        }
        else{
          navigate('/admin/products/listing/1');
        }
      }
      else{
        alert("Title already exist.");
        console.log(data.responce);
      }
    });
  }
 
  const deactivateProduct = ()=>{
    fetch(ApiUrl.API_URL_ListingActive, {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer '+Admin.token
      },
      body: JSON.stringify({
        id:item.id,
        active: false
      })
    })
    .then(res2=>res2.json())
    .then(data2 =>{
      if(data2.success){
        navigate('/admin/products/listing/1');
      }
      else{
        alert('Saved but activation failed');
      }
    });
  }

  const refrestVarients = ()=>{
    if(hasVarients){
      var varientSendList = [];
      for (let index = 0; index < sizes.length; index++) {
        const sizee = sizes[index];
        for (let index2 = 0; index2 < colors.length; index2++) {
          const colore = colors[index2];
          var notfound = true;
          for (let index3 = 0; index3 < item.listingVarients.length; index3++) {
            const varient = item.listingVarients[index3];
            if(String(varient.size) == sizee.value && String(varient.color) == colore.value){
              var sendcdelivery = {name:'Select', value:'0'};
              for (let index4 = 0; index4 < deliveryTypeList.length; index4++) {
                const element = deliveryTypeList[index4];
                if(element.value === String(varient.deliverytype)){
                  sendcdelivery = {
                    name: element.name,
                    value: String(element.value)
                  };
                }
              }
              varientSendList.push({
                title: sizee.name+"/"+colore.name,
                sku: varient.sku,
                price: varient.price,
                compareatprice:varient.compareatprice,
                deliverytype: sendcdelivery,
                count: varient.count,
                size: parseInt(sizee.value),
                color: parseInt(colore.value)
              })
              notfound = false;
            }
          }
          if(notfound){
            varientSendList.push({
              title: sizee.name+"/"+colore.name,
              sku: "",
              price: 0,
              compareatprice:0,
              deliverytype:{name:'Select', value:'0'},
              count: 0,
              size: parseInt(sizee.value),
              color: parseInt(colore.value)
            })
          }
        }
      }
      setVarients(varientSendList);
    }
    else{
      setVarients([]);
    }
  }


  const setIndexVSku = (i,val)=>{
    let sendlist = [];
    for (let index = 0; index < varients.length; index++) {
      const element = varients[index];
      if(i === index){
        element.sku = val;
      }
      sendlist.push(element);
    }
    setVarients(sendlist);
  }
  const setIndexVPrice = (i,val)=>{
    let sendlist = [];
    for (let index = 0; index < varients.length; index++) {
      const element = varients[index];
      if(i === index){
        element.price = val;
      }
      sendlist.push(element);
    }
    setVarients(sendlist);
  }
  const setIndexVCompareatprice = (i,val)=>{
    let sendlist = [];
    for (let index = 0; index < varients.length; index++) {
      const element = varients[index];
      if(i === index){
        element.compareatprice = val;
      }
      sendlist.push(element);
    }
    setVarients(sendlist);
  }
  const setIndexVdeliverytype = (i,val)=>{
    let sendlist = [];
    for (let index = 0; index < varients.length; index++) {
      const element = varients[index];
      if(i === index){
        element.deliverytype = val;
      }
      sendlist.push(element);
    }
    setVarients(sendlist);
  }
  const setIndexVCount = (i,val)=>{
    let sendlist = [];
    for (let index = 0; index < varients.length; index++) {
      const element = varients[index];
      if(i === index){
        element.count = val;
      }
      sendlist.push(element);
    }
    setVarients(sendlist);
  }


  useEffect(()=>{
    if(isUpdating){
      return;
    }
    refrestVarients();
  },[hasVarients,sizes,colors])

  const width = window.innerWidth;

  return (
    <>
      <div className='admin_forms_multirow'>
        <div className='admin_col_65'>
          <div className='product_add_title'><h3>Editing # {id}</h3></div>
        </div>
        <div className='admin_col_35'>
          <div className='product_add_button_container'>
            <GreenButton Value={'Save'} Action={()=>{add_admin(0)}}/>
            {item !== null && item.active &&
              <RedButton Value={'Deactivate'} Action= {()=>{deactivateProduct()}}/>
            }
            {item !== null && !item.active &&
              <RedButton Value={'Save & Activate'} Action= {()=>{add_admin(1)}}/>
            }
            <BlueButton Value={'Reset'} Action={()=>{document.location.reload();}}/>
          </div>
        </div>
      </div>
      <div className='admin_forms_multirow'>
        <div className={width > ScreenSizes.Mobile?'admin_col_65':'admin_col_100'} style={width > ScreenSizes.Mobile?{padding:"0px 10px"}:{}}>
          <div className='admin_forms_container'>
            <FormInput Lable='Title' Type='text' Placeholder='Enter name' Value={title} setValue={setTitle}/>
          </div>
          <div className='admin_forms_container'>
            <FormTextarea Lable='Discription' Placeholder='Enter discription' Value={discription} setValue={setDiscription}/>
          </div>
          <div className='admin_forms_container'>
            <div className='admin_forms_row'>
              <div className='admin_col_33'>
                <FormSelect Lable={'Packaging'} Value = {packaging} setValue={setPackaging} Options = {packagingList} />
              </div>
              <div className='admin_col_33'>
                <FormInput Lable={'Hscode'} Type={'text'} Placeholder={'Enter Hscode'} Value = {hscode} setValue = {setHscode} />
              </div>
              <div className='admin_col_33'>
                <FormInput Lable={'Weight'} Type={'number'} Placeholder={'Enter Weight'} Value = {weight} setValue = {setWeight} />
              </div>
            </div>
            {packaging.value === '2' &&
              <div className='admin_forms_row'>
                <div className='admin_col_33'>
                  <FormInput Lable={'Width'} Type={'number'} Placeholder={'Enter Width'} Value = {pwidth} setValue = {setWidth} />
                </div>
                <div className='admin_col_33'>
                  <FormInput Lable={'Height'} Type={'number'} Placeholder={'Enter Height'} Value = {pheight} setValue = {setHeight} />
                </div>
                <div className='admin_col_33'>
                  <FormInput Lable={'Length'} Type={'number'} Placeholder={'Enter Length'} Value = {plength} setValue = {setLength} />
                </div>
              </div>
            }
          </div>
          <div className='admin_forms_container'>
            <div className='admin_forms_multirow'>
              <div className='admin_col_33'>
                <label style={{cursor:"pointer"}}>
                    <div style={{
                        width: "100%",
                        paddingTop: "80%",
                        borderRadius: "3px",
                        border: "2px dashed black",
                        position: "relative"
                    }}>
                        <div style={{display:"flex", position:"absolute", top:"0", left:"0", bottom:"0", width:"100%", justifyContent:"center",alignItems:"center"}}>
                            <p>Add</p>
                        </div>
                        <input type="file" style={{display:"none"}} onChange={showPreview}/>
                    </div>
                </label>
              </div>
              {
                images.map((image,index)=>{
                  return(
                    <div className='admin_col_33' key={index}>
                      <label style={{cursor:"pointer"}}>
                              <div style={{
                                  width: "100%",
                                  paddingTop: "80%",
                                  borderRadius: "10px",
                                  position: "relative",
                                  backgroundImage:`url(${ApiUrl.API_URL_Image_Thumbnail+image})`,
                                  backgroundSize: 'cover',
                                  backgroundRepeat: 'no-repeat',
                                  backgroundPosition: 'center',
                                  
                              }}>
                                <div className='product_image_remove' onClick={()=>{
                                  remove_image(index);
                                }}>X</div>
                              </div>
                        </label>
                    </div>
                  )
                })
              }
            </div>
          </div>
          <div className='admin_forms_container'>
                <label style={{
                  fontSize:"12px",
                  margin:"20px 0px"
                }}>Recommendations</label>
            <div className='admin_forms_multirow'>
              <div className='admin_col_33' onClick={recommendationsPopUp}>
                <label style={{cursor:"pointer"}}>
                    <div style={{
                        width: "100%",
                        paddingTop: "80%",
                        borderRadius: "3px",
                        border: "2px dashed black",
                        position: "relative"
                    }}>
                        <div style={{display:"flex", position:"absolute", top:"0", left:"0", bottom:"0", width:"100%", justifyContent:"center",alignItems:"center"}}>
                            <p>Add</p>
                        </div>
                    </div>
                </label>
              </div>
              {
                recommendations.map((item,index)=>{
                  return(
                    <div className='admin_col_33' key={index}>
                      <label style={{cursor:"pointer"}}>
                              <div style={{
                                  width: "100%",
                                  paddingTop: "80%",
                                  borderRadius: "10px",
                                  position: "relative",
                                  backgroundImage:`url(${ApiUrl.API_URL_Image_Thumbnail+item.image})`,
                                  backgroundSize: 'cover',
                                  backgroundRepeat: 'no-repeat',
                                  backgroundPosition: 'center'
                              }}>
                                <div className='product_image_remove' onClick={()=>{
                                  removeRecommendation(item);
                                }}>X</div>
                              </div>
                        </label>
                    </div>
                  )
                })
              }
            </div>
          </div>
          <div className='admin_forms_row'>
            <div className={width > ScreenSizes.Mobile?'admin_col_33':'admin_col_100'} style={width > ScreenSizes.Mobile?{paddingRight:"10px"}:{}}>
              <div className='admin_forms_container' style={{
                minHeight:"232px"
              }}>
                <label style={{
                  fontSize:"12px"
                }}>#Hashtags</label>
                <IntrustInputSelect setValue={addIntrust} Options={intrustsFilter} AddRef={IntrustAddBox}/>
                <div className='register_intrustlist_container'>
                  { 
                    intrusts.map((item,index)=>{
                        return(
                          <div className='register_intrustlist_item' key={index}>
                            <div className='register_intrustlist_item_name'>
                              <p>#{item.name}</p>
                            </div>
                            <div className='register_intrustlist_item_remove' onClick={()=>{removeIntrust(item)}}>X</div>
                          </div>
                        )
                    })
                  }
                </div>
              </div>
            </div>
            <div className={width > ScreenSizes.Mobile?'admin_col_33':'admin_col_100'}>
              <div className='admin_forms_container' style={{
                minHeight:"232px"
              }}>
                <FormSelect Lable='Type' Value={type} setValue={change_type} Options={typeList}/>
                <label style={{
                  fontSize:"12px"
                }}>Sizes</label>
                <PimaryInputSelect setValue={addSize} Options={sizesFilter}/>
                <div className='register_intrustlist_container'>
                  { 
                    sizes.map((item,index)=>{
                        return(
                          <div className='register_intrustlist_item' key={index}>
                            <div className='register_intrustlist_item_name'>
                              <p>{item.name}</p>
                            </div>
                            <div className='register_intrustlist_item_remove' onClick={()=>{removeSize(item)}}>X</div>
                          </div>
                        )
                    })
                  }
                </div>
              </div>
            </div>
            <div className={width > ScreenSizes.Mobile?'admin_col_33':'admin_col_100'}>
              <div className='admin_forms_container' style={{
                minHeight:"232px"
              }}>
                <label style={{
                  fontSize:"12px"
                }}>Colors</label>
                <PimaryInputSelect setValue={addColor} Options={colorsFilter}/>
                <div className='register_intrustlist_container'>
                  { 
                    colors.map((item,index)=>{
                        return(
                          <div className='register_intrustlist_item' key={index} style={{
                            backgroundColor:item.code
                          }}>
                            <div className='register_intrustlist_item_name'>
                              <p>{item.name}</p>
                            </div>
                            <div className='register_intrustlist_item_remove' onClick={()=>{removeColor(item)}}>X</div>
                          </div>
                        )
                    })
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={width > ScreenSizes.Mobile?'admin_col_35':'admin_col_100'}>
          <div className='admin_forms_container'>
            <FormInput Lable='SKU' Type='text' Placeholder='Enter SKU' Value={sku} setValue={setSku}/>
            <FormInput Lable='Price' Type='number' Placeholder='Enter price' Value={price} setValue={setPrice}/>
            <FormInput Lable='Compare at Price' Type='number' Placeholder='Enter price before sale' Value={compareatprice} setValue={setCompareatprice}/>
          </div>
          <div className='admin_forms_container'>
            <FormSelect Lable='Brand' Value={brand} setValue={setBrand} Options={brandList}/>
            <FormSelect Lable='Condition' Value={condition} setValue={setCondition} Options={conditionList}/>
          </div>
          <div className='admin_forms_container'>
            {User.role === 'business' &&
              <FormSelect Lable='State' Value={state} setValue={change_state} Options={stateList}/>
            }
            <FormSelect Lable='Category' Value={category} setValue={change_category} Options={categoryList}/>
            <FormSelect Lable='Sub Category' Value={subcategory} setValue={setSubcategory} Options={subcategoryList}/>
          </div>
          <div className='admin_forms_container'>
            <FormSelect Lable='Delivery' Value={deliveryType} setValue={setDeliveryType} Options={deliveryTypeList}/>
            <FormInput Lable='Count' Type='number' Placeholder='Enter count for inventory/time' Value={counter} setValue={setCounter}/>
          </div>
          <div className={'admin_col_100'}>
            <div className='admin_forms_container' style={{
              minHeight:"178px"
            }}>
              <label style={{
                fontSize:"12px"
              }}>Collection</label>
              <PimaryInputSelect setValue={addCollection} Options={listCollectionFilter}/>
              <div className='register_intrustlist_container'>
                { 
                  listCollection.map((item,index)=>{
                      return(
                        <div className='register_intrustlist_item' key={index}>
                          <div className='register_intrustlist_item_name'>
                            <p>{item.name}</p>
                          </div>
                          <div className='register_intrustlist_item_remove' onClick={()=>{removeCollection(item)}}>X</div>
                        </div>
                      )
                  })
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='admin_forms_container' style={width>ScreenSizes.Mobile?{marginLeft:"10px"}:{}}>
        <div className="primary_checkbox_wrapper">
          <label>
            <input 
              type="checkbox" 
              checked={hasVarients}
              onChange={() => setHasvarients((prev) => !prev)}
            />
            <span>{"this product has varients"}</span>
          </label>
        </div>
        {hasVarients &&
          <div className='listing_varient_container'>
          {
            varients.map((varient,index)=>{
              return(
                <div className='admin_forms_row' key={index}>
                  <div className='admin_col_15'>
                    <FormInput Lable='Title' Type='text' Placeholder='' Value={varient.title} readonly={true}/>
                  </div>
                  <div className='admin_col_20'>
                    <FormInput Lable='Sku' Type='text' Placeholder='Enter SKU' Value={varient.sku} setValue={(e)=>{setIndexVSku(index,e)}}/>
                  </div>
                  <div className='admin_col_15'>
                    <FormInput Lable='Price' Type='number' Placeholder='Enter Price' Value={varient.price} setValue={(e)=>{setIndexVPrice(index,e)}}/>
                  </div>
                  <div className='admin_col_15'>
                    <FormInput Lable='Compare at Price' Type='number' Placeholder='Enter Compare at Price' Value={varient.compareatprice} setValue={(e)=>{setIndexVCompareatprice(index,e)}}/>
                  </div>
                  <div className='admin_col_20'>
                    <FormSelect Lable='Delivery' Value={varient.deliverytype} setValue={(e)=>{setIndexVdeliverytype(index,e)}} Options={deliveryTypeList}/>
                  </div>
                  <div className='admin_col_15'>
                    <FormInput Lable='Count' Type='number' Placeholder='Enter Count' Value={varient.count} setValue={(e)=>{setIndexVCount(index,e)}}/>
                  </div>
                </div>
              )
            })
          }
          </div>
        }
      </div>
      <div className='listing_recommendations_popup_wrapper' ref={recommendationsPop}>
        <div className='listing_recommendations_popup_container'>
          <div style={{
            padding:"20px 0px",
            width:"100%",
            display:"flex",
            justifyContent:"flex-end"
          }}>
            <p style={{
              padding:"10px"
            }} onClick={recommendationsPopDown}>X</p>
          </div>
              {
                recommendationsFilter.map((item,index)=>{
                  return(
                    <div className='admin_col_33' key={index} onClick={()=>{
                      addRecommendation(item);
                      recommendationsPopDown();
                    }}>
                      <label style={{cursor:"pointer"}}>
                              <div style={{
                                  width: "100%",
                                  paddingTop: "80%",
                                  borderRadius: "10px",
                                  position: "relative",
                                  backgroundImage:`url(${ApiUrl.API_URL_Image_Thumbnail+item.image})`,
                                  backgroundSize: 'cover',
                                  backgroundRepeat: 'no-repeat',
                                  backgroundPosition: 'center'
                              }}>
                              </div>
                        </label>
                    </div>
                  )
                })
              }
        </div>
      </div>
      <ListingIntust IntrustAddBox={IntrustAddBox} get_admin_list={get_admin_select}/>
    </>
  )
}

export default Listingedit
